import { render } from "./TheDeviceConfigurationsVehicles.vue?vue&type=template&id=5ae4f6aa"
import script from "./TheDeviceConfigurationsVehicles.vue?vue&type=script&lang=js"
export * from "./TheDeviceConfigurationsVehicles.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__